import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20composition%20with%20deep%20emerald%20green%20and%20black%20tones%2C%20mysterious%20floating%20geometric%20shapes%2C%20dramatic%20spotlight%20beams%20cutting%20through%20darkness%2C%20modern%20editorial%20design%20aesthetic%2C%20high%20contrast%20with%20deep%20rich%20shadows%20and%20bright%20rim%20lighting%2C%20sophisticated%20moody%20atmosphere%2C%20artistic%20negative%20space%2C%20no%20human%20figures%2C%20elegant%20atmospheric%20depth%20with%20subtle%20texture&width=1920&height=1080&seq=hero-main-bg-v2&orientation=landscape"
        alt="51吃瓜网"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="51吃瓜网 - 全网最新吃瓜爆料平台"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/65"></div>

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16">
        <div className="max-w-2xl">
          <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl font-black text-white leading-none tracking-tight">
            {t('hero.title.line1')}
            <br />
            {t('hero.title.line2')}
            <br />
            {t('hero.title.line3')}
          </h1>

          <Link
            to="/category/hot"
            className="inline-flex items-center gap-2 mt-8 px-8 py-3.5 rounded-full bg-accent-500/80 text-white text-base font-semibold whitespace-nowrap hover:bg-accent-500 transition-all duration-300 cursor-pointer backdrop-blur-sm"
          >
            {t('hero.cta')}
            <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>

      <div className="absolute bottom-10 md:bottom-16 left-0 w-full overflow-hidden pointer-events-none">
        <div className="whitespace-nowrap text-white/15 font-heading text-5xl md:text-8xl lg:text-9xl font-black tracking-wider leading-none px-6">
          {t('hero.bottom.text')}
        </div>
      </div>
    </section>
  );
}